import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { approvalService } from '@/services/approval.service';

export function usePendingApproversMap(instanceIds: Array<string | null | undefined>) {
  const ids = useMemo(
    () => [...new Set(instanceIds.filter((id): id is string => !!id))],
    [instanceIds]
  );

  const { data, isLoading } = useQuery({
    queryKey: ['pending-approvers', ids],
    queryFn: () => approvalService.getPendingApprovers(ids),
    enabled: ids.length > 0,
  });

  return {
    labels: data?.labels ?? {},
    approvers: data?.approvers ?? {},
    isLoading,
  };
}
